import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { HttpService } from 'src/app/http.service';
import { Location } from '@angular/common'
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-account-form',
  templateUrl: './account-form.component.html',
  styleUrls: ['./account-form.component.scss']
})
export class AccountFormComponent implements OnInit {

  @Input() set setData(v:any) {
    this.is_modal = true;
    this.data = v;
  }

  @Output() closeEvent = new EventEmitter();

  public is_modal = false;
  public is_loading = false;
  public expenses_uuid:any;
  public data:any = {type: "credit"}
  constructor(private http: HttpService, private location: Location, private activatedRoute: ActivatedRoute) { 
    let today = new Date()
    this.data.date = today.getFullYear() + "-" + ("0" + (today.getMonth() + 1)).slice(-2) + "-" + ("0" + (today.getDate())).slice(-2)
  
    this.activatedRoute.params.subscribe((v:any) => {

      if(v.uuid && v.uuid != "new" && !this.is_modal) {
        this.expenses_uuid = v.uuid;
        this.load(this.expenses_uuid);
      }
      
    })
  }

  async load(expenses_uuid:string) {
    const y:any = await this.http.post("/admin/account/expenses/get", {expenses_uuid});

    if(y.debit) {
      this.data.type = "debit"
      this.data.amount = y.debit
    } else {
      this.data.type = "credit"
      this.data.amount = y.credit
    }

    this.data.title = y.title;

    this.data.date = y.date;
    this.data.expenses_uuid = this.expenses_uuid;
  }

  ngOnInit(): void {
  }

  async submit() {

    if(this.is_loading) {
      return;
    }

    this.is_loading = true;

    const y = await this.http.post("/admin/account/create", this.data);
    
    if (!y['status']) {
      this.http.notify(y['message']);
      this.is_loading = false;
      return;
    }

    this.cancel();
    
  }

  cancel() {

    if(this.is_modal) {
      this.closeEvent.emit(true);
    } else {
      this.location.back()
    }
  }

}
